<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<el-radio-group
		v-bind="listenersComputed"
		class="qw-radio-group-root"
		:class="{'qw-radio-group-root--vertical': isVertical}">
		<slot></slot>
	</el-radio-group>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwRadioGroup",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		isVertical: Boolean,
	},

	watch: {
		"$attrs.modelValue"(newValue, oldValue) {
			this.prevValue = oldValue
			console.log("QwRadioGroup: $attrs.value changed: ", ...arguments)
		}
	},

	data() {
		return {
			prevValue: null
		}
	},
	methods: {
		name() {

		}
	},

	computed: {
		listenersComputed() {
			let changeLocal = this.$attrs.onChange || (() => {})
			let {onChange,  ...rest} = this.$attrs
			return {
				...rest,
				onChange: (value) => changeLocal(value, this.prevValue)
			}
		},
	},

}
</script>

<style lang="scss">
.qw-radio-group-root {
	&.el-radio-group{
		line-height: inherit;
	}

	> .qw-radio-root + .qw-radio-root {
		margin-left: 1rem;
	}

	&.qw-radio-group-root--vertical {
		> .qw-radio-root {
			display: flex;
			margin-left: 0;
		}

		> .qw-radio-root + .qw-radio-root {
			margin-top: 0.35rem;
		}
	}
}
</style>
